import { useStoreState } from '@src/model/hooks';
import { useEntityByIdentifier } from '@src/store/common/hooks/useEntityByIdentifier';
import { useMyReactions } from '@src/store/reactions/hooks/useMyReactions';
import { useEffect } from 'react';

export interface UsePostLoaderPayload {
    identifier?: string;
    includeMyReactions?: boolean;
}

export const usePostLoader = (payload: UsePostLoaderPayload) => {
    const { identifier, includeMyReactions = true } = payload;
    const entityType = 'Post';
    const myUserId = useStoreState(state => state.user.myUserId);

    const {
        entityId,
        load: loadPostEntity,
        loadStatus,
        error,
    } = useEntityByIdentifier({
        entityIdentifier: identifier,
        entityType,
    });

    const { loadMore: loadMoreReactions } = useMyReactions({ entityType, entityId: entityId });

    useEffect(() => {
        if (!myUserId || !entityId || !includeMyReactions) return;
        loadMoreReactions();
    }, [entityId, myUserId, includeMyReactions]);

    return {
        postId: entityId,
        load: loadPostEntity,
        loadStatus,
        error,
    };
};
